@if (addProjectToCollectionForm) {
  <div class="add-project-to-collection-dialog-container">
    <div class="hub-modal-header-text">
      <h5>Add '{{projectName}}' to a Record Collection</h5>
    </div>
    <div class="content">
      <form [formGroup]="addProjectToCollectionForm">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              @if (collections) {
                <div>
                  <span class="select-label text-info-700 d-block">Add this record to an existing Record
                  Collection</span>
                  <div class="hub-select-container">
                    @if (collections.length) {
                      <mat-form-field>
                        <mat-select placeholder="Select a Record Collection..." disableOptionCentering
                          formControlName="recordCollectionId">
                          @for (collection of collections; track collection) {
                            <mat-option [value]="collection.recordCollectionId">
                              <span>
                                {{collection.name}} ({{collection.recordCollectionType.name}})
                              </span>
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    } @else {
                      <span class="text-danger d-block">You currently do not have any Record Collections, you
                      have to create one first before you can add a record.</span>
                    }
                  </div>
                  <div class="hub-validation-error-message">
                    {{getValidationErrorMessages("recordCollectionId")}}
                  </div>
                </div>
              }
              <span class="select-label text-info-700 d-block mt-3 pt-2 sb-t">Create a new Record
              Collection</span>
              <button (click)="openCreateRecordCollectionDialog()"
                [disabled]="addProjectToCollectionForm.controls.recordCollectionId.value" type="button"
              style="margin-top: .625rem;">Create Collection</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="hub-modal-footer-text">
      <button type="button" class="cancel-button" (click)="close()">Cancel</button>
      <button type="button" [disabled]="addProjectToCollectionForm.invalid"
      (click)="save()">Add</button>
    </div>
  </div>
}
